export const techIconLibrary: any = {
	'react': {
		name: 'React',
		devIcon: 'devicon-react-original'
	},
	'redux': {
		name: 'Redux',
		devIcon: 'devicon-redux-original'
	},
	'node': {
		name: 'Node.js',
		devIcon: 'devicon-nodejs-plain'
	},
	'express': {
		name: 'Express.js',
		devIcon: 'devicon-express-original'
	},
	'mongodb': {
		name: 'Mongo DB',
		devIcon: 'devicon-mongodb-plain'
	},
	'html': {
		name: 'HTML5',
		devIcon: 'devicon-html5-plain'
	},
	'css': {
		name: 'CSS3',
		devIcon: 'devicon-css3-plain'
	},
	'js': {
		name: 'JavaScript',
		devIcon: 'devicon-javascript-plain'
	},
	'ionic': {
		name: 'Ionic',
		devIcon: 'devicon-ionic-original'
	},
	'angular': {
		name: 'Angular',
		devIcon: 'devicon-angularjs-plain'
	},
	'firebase': {
		name: 'Firebase',
		devIcon: 'devicon-firebase-plain'
	},
	'spring': {
		name: 'Spring',
		devIcon: 'devicon-spring-plain'
	},
	'mysql': {
		name: 'MySQL',
		devIcon: 'devicon-mysql-plain'
	},
	'unity': {
		name: 'Unity 3D',
		devIcon: 'devicon-unity-original'
	},
	'csharp': {
		name: 'C#',
		devIcon: 'devicon-csharp-plain'
	},
	'd3': {
		name: 'D3.js',
		devIcon: 'devicon-d3js-plain'
	}
}